// import React, { useState, useEffect } from "react";
// import {
//     useFormik,
//     FormikProvider,
//     Form,
//     Field,
//     ErrorMessage,
// } from "formik";
// import * as bie from "react-bootstrap";
// import { VscDiffAdded } from "react-icons/vsc";
// import { BiTrash } from "react-icons/bi";
// import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
// import { config } from "../../CommonUtils/CommonURLS";
// import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
// import Swal from "sweetalert2";
// import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
// import { FaEye } from "react-icons/fa";
// import { viewImage } from "../../CommonUtils/viewImage";
// import * as Yup from "yup";
// import { ERROR_MSG, IFSC_VALIDATION } from "../../CommonUtils/contextVariables";
// // ── constants ─────────────────────────────────────────────────────────────────
// const CUTOFF_YEAR = 2021;

// // ── helpers ───────────────────────────────────────────────────────────────────
// const yearsCompleted = (yearStr) => {
//     const y = parseInt(yearStr);
//     if (isNaN(y)) return "";
//     return new Date().getFullYear() - y;
// };

// const blankInstallment = () => ({
//     amount: "",
//     fromDate: "",
//     toDate: "",
//     fdrBankGuarantee: "",
//     fdrType: "",
//     dateOfFdr: "",
//     bankAddress: "",
//     ifsc: "",
//     dateOfMaturity: "",
//     dateOfRenewal: "",
//     uploadFdrBankGaurantee: "",
// });





// // ── small reusable components ─────────────────────────────────────────────────
// const FieldErr = ({ name }) => (
//     <ErrorMessage
//         name={name}
//         component="div"
//         className="text-danger small mt-1"
//     />
// );

// const SectionHeader = ({ title }) => (
//     <h5 className="mb-3 innerheader-new mt-4">
//         <span>{title}</span>
//     </h5>
// );

// const ORDINALS = ["First", "Second", "Third"];

// const TransposedBeforeTable = ({
//     fieldName,
//     label,
//     hasProgramme = false,
//     headerClass = "table-primary",
//     labelClass = "text-primary",
//     formik,
// }) => {
//     const installments = formik.values[fieldName] || [];

//     const addInstallment = () => {
//         const blank = hasProgramme
//             ? { programme: "", ...blankInstallment() }
//             : blankInstallment();
//         formik.setFieldValue(fieldName, [...installments, blank]);
//     };

//     const removeInstallment = (idx) => {
//         formik.setFieldValue(
//             fieldName,
//             installments.filter((_, i) => i !== idx),
//         );
//     };

//     const rows = [
//         ...(hasProgramme
//             ? [
//                 {
//                     key: "programme",
//                     label: "Programme",
//                     type: "text",
//                     placeholder: "Programme name",
//                 },
//             ]
//             : []),
//         { key: "amount", label: "Amount", type: "text", placeholder: "Amount" },
//         { key: "period", label: "Period (from – to)", type: "period" },
//         {
//             key: "fdrBankGuarantee",
//             label: "FDR / Bank Guarantee No.",
//             type: "text",
//             placeholder: "FDR No.",
//         },
//         { key: "dateOfFdr", label: "Date of FDR", type: "date" },
//         {
//             key: "bankAddress",
//             label: "Name & Address of Issuing Bank ",
//             type: "text",
//             placeholder: "Bank name",
//         },
//         {
//             key: "ifsc",
//             label: "IFSC",
//             type: "text",
//             placeholder: "Enter IFSC Code",

//         },
//         { key: "dateOfMaturity", label: "Date of Maturity", type: "date" },
//         { key: "dateOfRenewal", label: "Date of Renewal", type: "date" },
//         { key: "uploadFdrBankGaurantee", label: "Upload FDR / Bank Guarantee", type: "file" },
//     ];

//     return (
//         <div className="table-responsive mt-2">
//             <p className={`fw-semibold mb-1 ${labelClass}`}>{label}</p>

//             {/* Installment count control */}
//             <div className="d-flex align-items-center gap-2 mb-2">
//                 <span className="small fw-semibold">No. of Installments:</span>
//                 <button
//                     type="button"
//                     className="btn btn-danger btn-sm px-2 py-0"
//                     disabled={installments.length <= 1}
//                     onClick={() => removeInstallment(installments.length - 1)}
//                 >
//                     −
//                 </button>
//                 <span className="fw-bold">{installments.length}</span>
//                 <button
//                     type="button"
//                     className="btn btn-success btn-sm px-2 py-0"
//                     disabled={installments.length >= 3}
//                     onClick={addInstallment}
//                 >
//                     +
//                 </button>
//             </div>

//             <table className="table table-bordered table-sm align-middle">
//                 <thead className={headerClass}>
//                     <tr>
//                         <th style={{ minWidth: 220 }}>Required Information</th>
//                         {installments.map((_, i) => (
//                             <th key={i} className="text-center" style={{ minWidth: 160 }}>
//                                 {ORDINALS[i] || `#${i + 1}`} Installment
//                             </th>
//                         ))}
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {rows.map((row) => (
//                         <tr key={row.key}>
//                             <td className="fw-semibold text-nowrap bg-light">{row.label}</td>
//                             {installments?.map((_, i) => {
//                                 const base = `${fieldName}[${i}]`;
//                                 return (
//                                     <td key={i}>
//                                         {row.type === "text" && (
//                                             <>
//                                                 <Field
//                                                     type="text"
//                                                     name={`${base}.${row.key}`}
//                                                     className="form-control form-control-sm"
//                                                     placeholder={row.placeholder}
//                                                 />
//                                                 <FieldErr name={`${base}.${row.key}`} />
//                                             </>
//                                         )}
//                                         {row.type === "date" && (
//                                             <>
//                                                 <Field
//                                                     type="date"
//                                                     name={`${base}.${row.key}`}
//                                                     className="form-control form-control-sm"
//                                                 />
//                                                 <FieldErr name={`${base}.${row.key}`} />
//                                             </>
//                                         )}


//                                         {row.type === "period" && (
//                                             <div>
//                                                 <div className="d-flex gap-1 align-items-center">
//                                                     <div>
//                                                         <Field
//                                                             type="date"
//                                                             name={`${base}.fromDate`}
//                                                             max={new Date().toISOString().split("T")[0]}
//                                                             className="form-control form-control-sm"
//                                                         />
//                                                         <FieldErr name={`${base}.fromDate`} />
//                                                     </div>

//                                                     <span>–</span>

//                                                     <div>
//                                                         <Field
//                                                             type="date"
//                                                             name={`${base}.toDate`}
//                                                             min={
//                                                                 formik.values?.[fieldName]?.[i]?.fromDate || ""
//                                                             }
//                                                             className="form-control form-control-sm"
//                                                         />
//                                                         <FieldErr name={`${base}.toDate`} />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {/* {row?.type === "file" && (
//                                             <input
//                                                 type="file"
//                                                 className="form-control form-control-sm"
//                                                 accept="application/pdf"
//                                                 onChange={(e) => {
//                                                     let filename = "uploadFdrBankGaurantee" + i;
//                                                     let path = "/uploadFdrBankGaurantee/FDRDocuments/";

//                                                     ImagePdfBucket(
//                                                         e,
//                                                         formik,
//                                                         path,
//                                                         `${base}.uploadFdrBankGaurantee`,
//                                                         filename,
//                                                         "pdf"
//                                                     );
//                                                     formik.setFieldTouched(fieldName, true);
//                                                     formik.validateField(fieldName);
//                                                 }}



//                                             />


//                                         )} */}
//                                         {row?.type === "file" && (
//                                             <>
//                                                 <input
//                                                     type="file"
//                                                     className="form-control form-control-sm"
//                                                     accept="application/pdf"
//                                                     onChange={(e) => {
//                                                         const name = `${base}.uploadFdrBankGaurantee`;
//                                                         let filename = "uploadFdrBankGaurantee" + i;
//                                                         let path = "/uploadFdrBankGaurantee/FDRDocuments/";

//                                                         ImagePdfBucket(
//                                                             e,
//                                                             formik,
//                                                             path,
//                                                             name,
//                                                             filename,
//                                                             "pdf"
//                                                         );

//                                                         formik.setFieldTouched(name, true);
//                                                         formik.validateField(name);
//                                                     }}
//                                                 />

//                                                 {/* ✅ ERROR MESSAGE HERE */}
//                                                 <FieldErr name={`${base}.uploadFdrBankGaurantee`} />
//                                                 {formik.values?.[fieldName]?.[i]?.uploadFdrBankGaurantee && (
//                                                     <button
//                                                         type="button"
//                                                         className="btn btn-primary btn-sm mt-1"
//                                                         onClick={() =>
//                                                             viewImage(formik.values[fieldName][i].uploadFdrBankGaurantee)
//                                                         }
//                                                     >
//                                                         <FaEye />
//                                                     </button>
//                                                 )}
//                                             </>
//                                         )}
//                                     </td>
//                                 );
//                             })}
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );
// };

// const RowAfterTable = ({
//     fieldName,
//     label,
//     showMaturityRenewal = false,
//     headerClass = "table-primary",
//     labelClass = "text-primary",
//     formik,
//     courses,
// }) => {
//     const rows = formik.values[fieldName] || [];
//     const addRow = () => {
//         const blank = showMaturityRenewal
//             ? {
//                 courseId: "",
//                 amount: "",
//                 periodFrom: "",
//                 periodTo: "",
//                 fdrBankNumber: "",
//                 corpusDate: "",
//                 bankAddress: "",
//                 ifsc: "",
//                 dateMaturity: "",
//                 dateRenewal: "",
//                 uploadFdr: "",
//             }
//             : {
//                 courseId: "",
//                 amount: "",
//                 periodFrom: "",
//                 periodTo: "",
//                 fdrBankNumber: "",
//                 corpusDate: "",
//                 bankAddress: "",
//                 ifsc: "",
//                 uploadFdr: "",
//             };
//         formik.setFieldValue(fieldName, [...rows, blank]);
//     };

//     const removeRow = (idx) => {
//         formik.setFieldValue(
//             fieldName,
//             rows.filter((_, i) => i !== idx),
//         );
//     };

//     return (
//         <div className="table-responsive mt-2">
//             <p className={`fw-semibold mb-1 ${labelClass}`}>{label}</p>
//             <table className="table table-bordered table-sm align-middle">
//                 <thead className={headerClass}>
//                     <tr>
//                         <th>Sl. No.</th>
//                         <th>Programme</th>
//                         <th>Amount</th>
//                         <th>Period (from – to)</th>
//                         {/* {showMaturityRenewal ? <th> Select FDR / Bank Guarantee</th> : <th> FDR</th>} */}

//                         <th>
//                             {showMaturityRenewal === false
//                                 ? "Select FDR"
//                                 : "Select FDR / Bank Guarantee"}
//                         </th>

//                         {/* <th> Enter FDR / Bank Guarantee No </th> */}
//                         <th>
//                             {showMaturityRenewal === false
//                                 ? "Enter FDR"
//                                 : "Enter FDR / Bank Guarantee No"}
//                         </th>

//                         <th>Date</th>
//                         <th>Name &amp; Address of Issuing Bank</th>
//                         <th>IFSC</th>
//                         {showMaturityRenewal && <th>Date of Maturity</th>}
//                         {showMaturityRenewal && <th>Date of Renewal</th>}

//                         {/* <th>Upload FDR / Bank Guarantee</th> */}
//                         <th>
//                             {showMaturityRenewal === false
//                                 ? "Upload FDR"
//                                 : "Upload FDR / Bank Guarantee"}
//                         </th>

//                         <th>Action</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {rows.map((_, i) => {
//                         const base = `${fieldName}[${i}]`
//                         return (
//                             <tr key={i}>
//                                 <td className="text-center">{i + 1}</td>

//                                 <td>
//                                     <Field
//                                         as="select"
//                                         name={`${base}.courseId`}
//                                         className="form-control form-control-sm"
//                                     >
//                                         <option value="">---Select Programme---</option>

//                                         {(() => {
//                                             // Get all selected programme ids
//                                             const selectedProgrammes =
//                                                 formik.values[fieldName]
//                                                     ?.map((r) => r.programme)
//                                                     ?.filter(Boolean) || [];

//                                             return (courses || [])
//                                                 .filter((course) => {
//                                                     // Allow current row selected value
//                                                     const currentValue =
//                                                         formik.values[fieldName][i]?.programme;

//                                                     return (
//                                                         !selectedProgrammes.includes(
//                                                             String(course.course_id),
//                                                         ) ||
//                                                         String(course.course_id) === String(currentValue)
//                                                     );
//                                                 })
//                                                 .map((course) => (
//                                                     <option
//                                                         key={course.course_id}
//                                                         value={course.course_id}
//                                                     >
//                                                         {course.course_name}
//                                                     </option>
//                                                 ));
//                                         })()}
//                                     </Field>

//                                     <FieldErr name={`${base}.courseId`} />
//                                 </td>
//                                 <td>
//                                     <Field type="text" name={`${base}.amount`}
//                                         className="form-control form-control-sm" placeholder="Amount" />
//                                     <FieldErr name={`${base}.amount`} />
//                                 </td>


//                                 <td>
//                                     <div className="d-flex gap-1 align-items-center">
//                                         <div>
//                                             <Field
//                                                 type="date"
//                                                 name={`${base}.periodFrom`}
//                                                 max={new Date().toISOString().split("T")[0]}
//                                                 className="form-control form-control-sm"
//                                             />
//                                             <FieldErr name={`${base}.periodFrom`} />
//                                         </div>

//                                         <span>–</span>

//                                         <div>
//                                             <Field
//                                                 type="date"
//                                                 name={`${base}.periodTo`}
//                                                 min={
//                                                     formik.values?.[fieldName]?.[i]?.periodFrom || ""
//                                                 }
//                                                 className="form-control form-control-sm"
//                                             />
//                                             <FieldErr name={`${base}.periodTo`} />
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>
//                                     <Field as="select" name={`${base}.fdrType`} className="form-control select-input" >
//                                         <option value="">Select type</option>
//                                         <option value="FDR">FDR</option>
//                                         <option value="Bank Guarantee"> Bank Guarantee </option>
//                                     </Field>
//                                     <FieldErr name={`${base}.fdrType`} />
//                                 </td>
//                                 <td>
//                                     <Field type="text" name={`${base}.fdrBankNumber`} className="form-control form-control-sm" placeholder="FDR No / Bank Guarantee No." />

//                                     <FieldErr name={`${base}.fdrBankNumber`} />
//                                 </td>

//                                 <td>
//                                     <Field
//                                         type="date"
//                                         name={`${base}.corpusDate`}
//                                         className="form-control form-control-sm"
//                                         max={new Date().toISOString().split("T")[0]} // ✅ today date

//                                     />
//                                     <FieldErr name={`${base}.corpusDate`} />
//                                 </td>
//                                 <td>
//                                     <Field
//                                         type="text"
//                                         name={`${base}.bankAddress`}
//                                         className="form-control form-control-sm"
//                                         placeholder="Bank name "
//                                     />
//                                     <FieldErr name={`${base}.bankAddress`} />
//                                 </td>


//                                 <td>
//                                     <Field
//                                         type="text"
//                                         name={`${base}.ifsc`}
//                                         className="form-control form-control-sm"
//                                         placeholder=" Enter IFSC "
//                                     />
//                                     <FieldErr name={`${base}.ifsc`} />
//                                 </td>
//                                 {showMaturityRenewal && (
//                                     <td>
//                                         <Field
//                                             type="date"
//                                             name={`${base}.dateMaturity`}
//                                             className="form-control form-control-sm"
//                                             onChange={(e) => {
//                                                 formik.setFieldValue(`${base}.dateMaturity`, e.target.value);
//                                                 formik.setFieldTouched(`${base}.dateMaturity`, true);
//                                             }}
//                                         />
//                                         <FieldErr name={`${base}.dateMaturity`} />
//                                     </td>
//                                 )}
//                                 {showMaturityRenewal && (
//                                     <td>
//                                         <Field
//                                             type="date"
//                                             name={`${base}.dateRenewal`}
//                                             className="form-control form-control-sm"
//                                             onChange={(e) => {
//                                                 formik.setFieldValue(`${base}.dateRenewal`, e.target.value);
//                                                 formik.setFieldTouched(`${base}.dateRenewal`, true);
//                                             }}
//                                         />
//                                         <FieldErr name={`${base}.dateRenewal`} />
//                                     </td>
//                                 )}

//                                 <td>
//                                     <input
//                                         type="file"
//                                         className="form-control form-control-sm"
//                                         accept="application/pdf"
//                                         onChange={(e) => {

//                                             let filename = `uploadFdr_${i}`; // i = row index
//                                             let path = "/Uploads/FDRDocuments/";

//                                             ImagePdfBucket(
//                                                 e,
//                                                 formik,
//                                                 path,
//                                                 `${base}.uploadFdr`, // Formik field name
//                                                 filename,
//                                                 "pdf"
//                                             );
//                                         }}


//                                     />
//                                     <FieldErr name={`${base}.uploadFdr`} />
//                                     {formik.values?.[fieldName]?.[i]?.uploadFdr && (
//                                         <button
//                                             type="button"
//                                             className="btn btn-primary btn-sm mt-1"
//                                             onClick={() =>
//                                                 viewImage(formik.values[fieldName][i].uploadFdr)
//                                             }
//                                         >
//                                             <FaEye />
//                                         </button>
//                                     )}
//                                 </td>
//                                 <td className="text-center">
//                                     {i === 0 ? (
//                                         <button
//                                             type="button"
//                                             className="btn btn-success btn-sm"
//                                             onClick={addRow}
//                                         >
//                                             <VscDiffAdded />
//                                         </button>
//                                     ) : (
//                                         <button
//                                             type="button"
//                                             className="btn btn-danger btn-sm"
//                                             onClick={() => removeRow(i)}
//                                         >
//                                             <BiTrash />
//                                         </button>
//                                     )}
//                                 </td>
//                             </tr>
//                         );
//                     })}
//                 </tbody>
//             </table>
//         </div>
//     );
// };

// // ── main component ────────────────────────────────────────────────────────────
// export default function EOP({ paymentDone }) {
//     console.log("paymentDone", paymentDone)
//     const [hasPG, setHasPG] = useState(false);
//     const [clgtype, setClgtype] = useState([]);
//     const [clgYear, setClgYear] = useState("");
//     const [ugData, setUgData] = useState(null);
//     const [pgData, setPgData] = useState(null);
//     const [ugCourse, setUgCourse] = useState([]);
//     const [pgCourse, setPgCourse] = useState([]);
//     function GetUgCourses() {
//         CommonAxiosGet(`${config.url.FAC_URL}getUGCourses`).then((res) => {
//             if (res?.data?.scode === "01") {
//                 setUgCourse(res.data.data);
//             } else {
//                 setUgCourse([]);
//             }
//         });
//     }

//     function GetPGCourses() {
//         CommonAxiosGet(`${config.url.FAC_URL}getPGCourses`).then((res) => {
//             if (res?.data?.scode === "01") {
//                 setPgCourse(res.data.data);
//             } else {
//                 setPgCourse([]);
//             }
//         });
//     }

//     function GetClgtype() {
//         CommonAxiosGet(`${config.url.FAC_URL}getCourseTypes`).then((res) => {
//             if (res?.data?.scode === "01") {
//                 const data = res.data.data || [];
//                 setClgtype(data);

//                 const ug = data.find((d) => d.course_type === "UG") || "";
//                 const pg = data.find((d) => d.course_type === "PG") || "";
//                 setUgData(ug);
//                 setPgData(pg);

//                 if (pg) setHasPG(true);

//                 const year = ug?.year_of_establishment ?? pg?.year_of_establishment
//                 if (year) {
//                     setClgYear(String(year))
//                     formik.setFieldValue('establishYear', String(year))
//                 }
//             }
//         })
//     }

//     useEffect(() => {
//         GetClgtype()
//         GetUgCourses();
//         GetPGCourses();
//     }, [])
//     const havUG = clgtype?.some(item => item.course_type === "UG");
//     const havPG = clgtype?.some(item => item.course_type === "PG");


//     const showPGCorpus = havUG && havPG;
//     const estYear = parseInt(clgYear) || 0;
//     const isBefore = estYear > 0 && estYear <= CUTOFF_YEAR;

//     const isAfter = estYear > 0 && estYear > CUTOFF_YEAR;

//     const getValidationSchema = (hasUG, hasPG, isBefore, isAfter) =>
//         Yup.object({
//             ruralArea: Yup.string().required("Please select Rural/Tribal area"),

//             mroDocument: Yup.string().when("ruralArea", {
//                 is: "Yes",
//                 then: () => Yup.string().required("MRO document is required"),
//                 otherwise: () => Yup.string().nullable(),
//             }),

//             before2122Details: Yup.array().when([], {
//                 is: () => hasUG && isBefore,
//                 then: () =>
//                     Yup.array().of(
//                         Yup.object({
//                             amount: Yup.string().required(ERROR_MSG),
//                             fromDate: Yup.string().required(ERROR_MSG),
//                             toDate: Yup.string().required(ERROR_MSG),
//                             fdrBankGuarantee: Yup.string().required(ERROR_MSG),
//                             dateOfFdr: Yup.string().required(ERROR_MSG),
//                             bankAddress: Yup.string().required(ERROR_MSG),
//                             ifsc: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION),
//                             uploadFdrBankGaurantee: Yup.string().required(ERROR_MSG),
//                             // dateOfMaturity: Yup.string().nullable(),
//                             // dateOfRenewal: Yup.string().nullable(),
//                             dateOfMaturity: Yup.string().required(ERROR_MSG),
//                             dateOfRenewal: Yup.string().required(ERROR_MSG),


//                         })
//                     ),
//                 otherwise: () => Yup.array().notRequired(),
//             }),

//             after2122Details: Yup.array().when([], {
//                 is: () => hasUG && isAfter,
//                 then: () =>
//                     Yup.array().of(
//                         Yup.object({
//                             courseId: Yup.string().required(ERROR_MSG),
//                             amount: Yup.string().required(ERROR_MSG),
//                             periodFrom: Yup.string().required(ERROR_MSG),
//                             periodTo: Yup.string().required(ERROR_MSG),
//                             fdrType: Yup.string().required(ERROR_MSG),
//                             fdrBankNumber: Yup.string().required(ERROR_MSG),
//                             corpusDate: Yup.string().required(ERROR_MSG),
//                             bankAddress: Yup.string().required(ERROR_MSG),
//                             ifsc: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION),
//                             uploadFdr: Yup.string().required(ERROR_MSG),
//                         })
//                     ),
//                 otherwise: () => Yup.array().notRequired(),
//             }),

//             pgDetails: Yup.array().when([], {
//                 is: () => hasPG,
//                 then: () =>
//                     Yup.array().of(
//                         Yup.object({
//                             courseId: Yup.string().required(ERROR_MSG),
//                             amount: Yup.string().required(ERROR_MSG),
//                             periodFrom: Yup.string().required(ERROR_MSG),
//                             periodTo: Yup.string().required(ERROR_MSG),
//                             fdrType: Yup.string().required(ERROR_MSG),
//                             fdrBankNumber: Yup.string().required(ERROR_MSG),
//                             corpusDate: Yup.string().required(ERROR_MSG),
//                             bankAddress: Yup.string().required(ERROR_MSG),
//                             ifsc: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION),
//                             uploadFdr: Yup.string().required(ERROR_MSG),
//                             dateMaturity: Yup.string().required(ERROR_MSG),
//                             dateRenewal: Yup.string().required(ERROR_MSG),
//                         })
//                     ),
//                 otherwise: () => Yup.array().notRequired(),
//             }),
//         });
//     const formik = useFormik({
//         enableReinitialize: true,
//         initialValues: {
//             ruralArea: '',
//             mroDocument: '',

//             before2122Details: [blankInstallment()],

//             after2122Details: [{
//                 courseId: '',
//                 amount: '',
//                 periodFrom: '',
//                 periodTo: '',
//                 fdrBankNumber: '',
//                 fdrType: '',
//                 corpusDate: '',
//                 bankAddress: '',
//                 dateMaturity: '',
//                 dateRenewal: '',
//                 uploadFdr: ''
//             }],

//             pgDetails: [{
//                 courseId: '',
//                 amount: '',
//                 periodFrom: '',
//                 periodTo: '',
//                 fdrBankNumber: '',
//                 fdrType: '',
//                 corpusDate: '',
//                 bankAddress: '',
//                 dateMaturity: '',
//                 dateRenewal: '',
//                 uploadFdr: ''
//             }]
//         },


//         // validationSchema: EopValidationSchema,
//         validationSchema: getValidationSchema(havUG, havPG, isBefore, isAfter),

//         onSubmit: (values) => {

//             const before2122Details = values.before2122Details.map((item, idx) => ({
//                 ...item,
//                 installmentNo: idx + 1,
//             }));

//             // Construct payload
//             const payload = {
//                 ...values,
//                 before2122Details,     // with updated installmentNo
//                 after2122Details: values.after2122Details, // UG + PG together
//                 pgDetails: values.pgDetails, // PG details
//                 // no need for pgAfter2122Details
//             };

//             Swal.fire({
//                 text: 'Are you sure you want to submit?',
//                 icon: 'warning',
//                 showCancelButton: true,
//                 confirmButtonText: 'Yes, submit it!',
//                 cancelButtonText: 'No, cancel!',
//                 backdrop: false,
//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     let url = config.url.FAC_URL + `saveCorpusFundDetailsBefore2122`
//                     CommonAxiosPost(url, payload).then((res) => {
//                         if (res?.data?.scode === '01') {
//                             successAlert2(res?.data?.sdesc);
//                             // goNext();

//                         }
//                         else if (res?.data?.scode === '02') {
//                             Swal.fire(res?.data?.sdesc, '', 'error').then((res) => {
//                             })
//                         }
//                         else {
//                             failureAlert("Failed to submit")

//                         }
//                     })
//                 }
//             });

//         }



//     })

//     useEffect(() => {
//         const y = yearsCompleted(formik.values.establishYear);
//         formik.setFieldValue("leasedYears", y);
//     }, [formik.values.establishYear]);

//     // const estYear = parseInt(formik.values.establishYear) || 0;
//     // const isBefore = estYear > 0 && estYear <= CUTOFF_YEAR;
//     // const isAfter = estYear > 0 && estYear > CUTOFF_YEAR;

//     const [clgdata, setClgdata] = useState([]);
//     function GetCollegeData() {
//         CommonAxiosGet(`${config.url.FAC_URL}getInstitutionPolyDetails`).then((res) => {
//             const data = res?.data?.data?.[0] || {};
//             setClgdata(data);


//         });
//     }
//     function mapEopToFormik(data) {

//         // ✅ AFTER 2021 (UG/PG rows)
//         const afterData = (data?.corpusfundUGPG || []).map(item => ({
//             courseId: item.course_id || '',
//             amount: item.amount || '',
//             periodFrom: item.period_from || '',
//             periodTo: item.period_to || '',
//             fdrBankNumber: item.fdr_bank_number || '',
//             fdrType: item.fdr_type || '',
//             corpusDate: item.corpus_date || '',
//             bankAddress: item.bank_address || '',
//             ifsc: item.ifsc || '',
//             dateMaturity: item.date_maturity || '',
//             dateRenewal: item.date_renewal || '',
//             uploadFdr: item.upload_fdr || ''
//         }));

//         // ✅ BEFORE 2021 (Installments table)
//         const beforeData = (data?.corpusFundInstall || []).map(item => ({
//             amount: item.amount || '',
//             fromDate: item.from_date || '',
//             toDate: item.to_date || '',
//             fdrBankGuarantee: item.fdr_bank_guarantee || '',
//             fdrType: '', // not coming from API
//             dateOfFdr: item.date_of_fdr || '',
//             bankAddress: item.bank_address || '',
//             ifsc: item.ifsc || '',
//             dateOfMaturity: item.date_of_maturity || '',
//             dateOfRenewal: item.date_of_renewal || '',
//             uploadFdrBankGaurantee: item.upload_fdr_bank_gaurantee || ''
//         }));

//         // ✅ Rural Area + MRO Document
//         const ruralArea = data?.corpusFundInstall?.[0]?.rural_area || '';
//         const mroDocument = data?.corpusFundInstall?.[0]?.mro_document || '';

//         // ✅ SET TO FORMIK
//         formik.setValues(prev => ({
//             ...prev,
//             ruralArea,
//             mroDocument,

//             before2122Details: beforeData.length
//                 ? beforeData
//                 : [blankInstallment()],

//             after2122Details: afterData.length
//                 ? afterData
//                 : prev.after2122Details
//         }));
//     }
//     function GetEopDetails() {
//         CommonAxiosGet(`${config.url.FAC_URL}getEOPDetails`).then((res) => {
//             const data = res?.data || {};   // ✅ correct
//             // setEopData(data);

//             mapEopToFormik(data);           // ✅ call mapping here
//         });
//     }



//     useEffect(() => {
//         GetCollegeData();
//         GetEopDetails();
//     }, [])



//     const labelStyle = {
//         fontWeight: 600,
//         color: "#004d40",
//         marginBottom: 6,
//         fontSize: 18,
//     };


//     return (
//         <>

//             <div className="faculty-form-wrapper">
//                 <div className="faculty-card">
//                     <SectionHeader title="Extension of Permission (EoP)" />

//                     <FormikProvider value={formik}>
//                         <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit}>



//                             <bie.Row>
//                                 <bie.Col xs={12} md={4} lg={4} className="mb-3">

//                                     <div style={labelStyle}>
//                                         <strong>Year of Establishment:</strong> {clgdata?.year_of_establishment || "--"}
//                                     </div>                                </bie.Col>
//                                 <bie.Col xs={12} md={4} lg={4} className="mb-3">
//                                     <label className="mb-1">
//                                         <b className="field-mandatory">
//                                             Whether the college is located in a Rural / Tribal area
//                                         </b>
//                                     </label>
//                                     <div className="mt-1">
//                                         <Field type="radio" name="ruralArea" value="Yes" />&nbsp;Yes&emsp;
//                                         <Field type="radio" name="ruralArea" value="No" />&nbsp;No
//                                     </div>
//                                     <FieldErr name="ruralArea" />

//                                 </bie.Col>

//                                 {formik.values.ruralArea === 'Yes' && (
//                                     <bie.Col xs={12} md={4} lg={4} className="mb-3">
//                                         <label className="mb-1">
//                                             <b className="field-mandatory">Upload the certificate issued by concerned MRO</b>
//                                         </label>

//                                         <input
//                                             type="file"
//                                             className="form-control"
//                                             accept="application/pdf"
//                                             onChange={(e) => {
//                                                 const filename = "_mroDocument";  // dynamic filename
//                                                 const path = "/Uploads/MroDocument/"; // destination folder
//                                                 ImagePdfBucket(e, formik, path, "mroDocument", filename, "pdf");
//                                             }}
//                                         />
//                                         <FieldErr name="mroDocument" />

//                                         {formik.values.mroDocument && (
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-primary btn-sm mt-2"
//                                                 onClick={() => viewImage(formik.values.mroDocument)}
//                                             ><FaEye />
//                                             </button>
//                                         )}
//                                     </bie.Col>
//                                 )}

//                             </bie.Row>
//                             {ugData && estYear > 0 && (
//                                 <div className="px-2 mt-2">
//                                     <h6 className="innerheader-new">
//                                         <span>UG Corpus Fund</span>
//                                     </h6>

//                                     {isBefore && (
//                                         <TransposedBeforeTable
//                                             fieldName="before2122Details"
//                                             label=" For Degree Colleges established before 2021-22"
//                                             hasProgramme={false}
//                                             headerClass="table-primary"
//                                             labelClass="text-primary"
//                                             formik={formik}
//                                         />
//                                     )}

//                                     {/* UG After 2021 — row-per-entry, no maturity/renewal */}
//                                     <div className={isBefore ? "mt-3" : ""}>
//                                         <RowAfterTable
//                                             fieldName="after2122Details"
//                                             label=" For Degree Colleges / programmes sanctioned after 2021-22"
//                                             showMaturityRenewal={false}
//                                             headerClass="table-primary"
//                                             labelClass="text-primary"
//                                             formik={formik}
//                                             courses={ugCourse}
//                                         />
//                                     </div>
//                                 </div>
//                             )}


//                             {showPGCorpus && (
//                                 <div className="px-2 mt-4">
//                                     <h6 className="innerheader-new"><span>PG Corpus Fund</span></h6>

//                                     {isBefore && (
//                                         <RowAfterTable
//                                             fieldName="pgDetails"
//                                             label=" For existing PG Programmes sanctioned (before 2021-22 and after 2021-22)"
//                                             showMaturityRenewal={true}
//                                             headerClass="table-success"
//                                             labelClass="text-success"
//                                             formik={formik}
//                                             courses={pgCourse}

//                                         />
//                                     )}

//                                 </div>
//                             )}


//                             {/* <bie.Row className="mt-4 px-2">
//                                 <bie.Col className="text-end">
//                                     <button type="submit" className="btn btn-success btn-sm">
//                                         Submit
//                                     </button>
//                                 </bie.Col>
//                             </bie.Row> */}

//                             <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
//                                 {paymentDone ? (
//                                     <div style={{ color: "green", fontWeight: "bold" }}>
//                                         ✅ Already submitted
//                                     </div>
//                                 ) : (
//                                     <button
//                                         type="submit"
//                                         className="btn btn-success btn-sm"
//                                     >
//                                         Submit
//                                     </button>
//                                 )}
//                             </div>


//                         </Form>
//                     </FormikProvider>
//                 </div>
//             </div >
//         </>

//     )
// }







import React, { useState, useEffect } from "react";
import {
    useFormik,
    FormikProvider,
    Form,
    Field,
    ErrorMessage,
} from "formik";
import * as bie from "react-bootstrap";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import Swal from "sweetalert2";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { FaEye } from "react-icons/fa";
import { viewImage } from "../../CommonUtils/viewImage";
import * as Yup from "yup";
import { ERROR_MSG, IFSC_VALIDATION } from "../../CommonUtils/contextVariables";
// ── constants ─────────────────────────────────────────────────────────────────
const CUTOFF_YEAR = 2021;

// ── helpers ───────────────────────────────────────────────────────────────────
const yearsCompleted = (yearStr) => {
    const y = parseInt(yearStr);
    if (isNaN(y)) return "";
    return new Date().getFullYear() - y;
};

const blankInstallment = () => ({
    amount: "",
    fromDate: "",
    toDate: "",
    fdrBankGuarantee: "",
    fdrType: "",
    dateOfFdr: "",
    bankAddress: "",
    ifsc: "",
    dateOfMaturity: "",
    dateOfRenewal: "",
    uploadFdrBankGaurantee: "",
});


// ── small reusable components ─────────────────────────────────────────────────
const FieldErr = ({ name }) => (
    <ErrorMessage
        name={name}
        component="div"
        className="text-danger small mt-1"
    />
);

const SectionHeader = ({ title }) => (
    <h5 className="mb-3 innerheader-new mt-4">
        <span>{title}</span>
    </h5>
);

const ORDINALS = ["First", "Second", "Third"];

const TransposedBeforeTable = ({
    fieldName,
    label,
    hasProgramme = false,
    headerClass = "table-primary",
    labelClass = "text-primary",
    formik,
}) => {
    const installments = formik.values[fieldName] || [];

    const addInstallment = () => {
        const blank = hasProgramme
            ? { programme: "", ...blankInstallment() }
            : blankInstallment();
        formik.setFieldValue(fieldName, [...installments, blank]);
    };

    const removeInstallment = (idx) => {
        formik.setFieldValue(
            fieldName,
            installments.filter((_, i) => i !== idx),
        );
    };

    const rows = [
        ...(hasProgramme
            ? [
                {
                    key: "programme",
                    label: "Programme",
                    type: "text",
                    placeholder: "Programme name",
                },
            ]
            : []),
        { key: "amount", label: "Amount", type: "text", placeholder: "Amount" },
        { key: "period", label: "Period (from – to)", type: "period" },
        {
            key: "fdrBankGuarantee",
            label: "FDR / Bank Guarantee No.",
            type: "text",
            placeholder: "FDR No.",
        },
        { key: "dateOfFdr", label: "Date of FDR", type: "date" },
        {
            key: "bankAddress",
            label: "Name & Address of Issuing Bank ",
            type: "text",
            placeholder: "Bank name",

        },
        {
            key: "ifsc",
            label: "IFSC",
            type: "text",
            placeholder: "Enter IFSC Code",

        },
        { key: "dateOfMaturity", label: "Date of Maturity", type: "date" },
        { key: "dateOfRenewal", label: "Date of Renewal", type: "date" },
        { key: "uploadFdrBankGaurantee", label: "Upload FDR / Bank Guarantee", type: "file" },
    ];

    return (
        <div className="table-responsive mt-2">
            <p className={`fw-semibold mb-1 ${labelClass}`}>{label}</p>

            {/* Installment count control */}
            <div className="d-flex align-items-center gap-2 mb-2">
                <span className="small fw-semibold">No. of Installments:</span>
                <button
                    type="button"
                    className="btn btn-danger btn-sm px-2 py-0"
                    disabled={installments.length <= 1}
                    onClick={() => removeInstallment(installments.length - 1)}
                >
                    −
                </button>
                <span className="fw-bold">{installments.length}</span>
                <button
                    type="button"
                    className="btn btn-success btn-sm px-2 py-0"
                    disabled={installments.length >= 3}
                    onClick={addInstallment}
                >
                    +
                </button>
            </div>

            <table className="table table-bordered table-sm align-middle">
                <thead className={headerClass}>
                    <tr>
                        <th style={{ minWidth: 220 }}>Required Information</th>
                        {installments.map((_, i) => (
                            <th key={i} className="text-center" style={{ minWidth: 160 }}>
                                {ORDINALS[i] || `#${i + 1}`} Installment
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.key}>
                            <td className="fw-semibold text-nowrap bg-light">{row.label}</td>
                            {installments?.map((_, i) => {
                                const base = `${fieldName}[${i}]`;
                                return (
                                    <td key={i}>
                                        {row.type === "text" && (
                                            <>
                                                <Field
                                                    type="text"
                                                    name={`${base}.${row.key}`}
                                                    className="form-control form-control-sm"
                                                    placeholder={row.placeholder}
                                                />
                                                <FieldErr name={`${base}.${row.key}`} />
                                            </>
                                        )}
                                        {row.type === "date" && (
                                            <>
                                                <Field
                                                    type="date"
                                                    name={`${base}.${row.key}`}
                                                    className="form-control form-control-sm"
                                                />
                                                <FieldErr name={`${base}.${row.key}`} />
                                            </>
                                        )}


                                        {row.type === "period" && (
                                            <div>
                                                <div className="d-flex gap-1 align-items-center">
                                                    <div>
                                                        <Field
                                                            type="date"
                                                            name={`${base}.fromDate`}
                                                            max={new Date().toISOString().split("T")[0]}
                                                            className="form-control form-control-sm"
                                                        />
                                                        <FieldErr name={`${base}.fromDate`} />
                                                    </div>

                                                    <span>–</span>

                                                    <div>
                                                        <Field
                                                            type="date"
                                                            name={`${base}.toDate`}
                                                            min={
                                                                formik.values?.[fieldName]?.[i]?.fromDate || ""
                                                            }
                                                            className="form-control form-control-sm"
                                                        />
                                                        <FieldErr name={`${base}.toDate`} />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {row?.type === "file" && (
                                            <>
                                                <input
                                                    type="file"
                                                    className="form-control form-control-sm"
                                                    accept="application/pdf"
                                                    onChange={(e) => {
                                                        const name = `${base}.uploadFdrBankGaurantee`;
                                                        let filename = "uploadFdrBankGaurantee" + i;
                                                        let path = "/uploadFdrBankGaurantee/FDRDocuments/";

                                                        ImagePdfBucket(
                                                            e,
                                                            formik,
                                                            path,
                                                            name,
                                                            filename,
                                                            "pdf"
                                                        );

                                                        formik.setFieldTouched(name, true);
                                                        formik.validateField(name);
                                                    }}
                                                />

                                                <FieldErr name={`${base}.uploadFdrBankGaurantee`} />
                                                {formik.values?.[fieldName]?.[i]?.uploadFdrBankGaurantee && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-sm mt-1"
                                                        onClick={() =>
                                                            viewImage(formik.values[fieldName][i].uploadFdrBankGaurantee)
                                                        }
                                                    >
                                                        <FaEye />
                                                    </button>
                                                )}
                                            </>
                                        )}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const RowAfterTable = ({
    fieldName,
    label,
    showMaturityRenewal = false,
    headerClass = "table-primary",
    labelClass = "text-primary",
    formik,
    courses,
}) => {
    const rows = formik.values[fieldName] || [];
    const addRow = () => {
        const blank = showMaturityRenewal
            ? {
                courseId: "",
                amount: "",
                periodFrom: "",
                periodTo: "",
                fdrBankNumber: "",
                corpusDate: "",
                bankAddress: "",
                ifsc: "",
                dateMaturity: "",
                dateRenewal: "",
                uploadFdr: "",
            }
            : {
                courseId: "",
                amount: "",
                periodFrom: "",
                periodTo: "",
                fdrBankNumber: "",
                corpusDate: "",
                bankAddress: "",
                ifsc: "",
                uploadFdr: "",
            };
        formik.setFieldValue(fieldName, [...rows, blank]);
    };

    const removeRow = (idx) => {
        formik.setFieldValue(
            fieldName,
            rows.filter((_, i) => i !== idx),
        );
    };

    return (
        <div className="table-responsive mt-2">
            <p className={`fw-semibold mb-1 ${labelClass}`}>{label}</p>
            <table className="table table-bordered table-sm align-middle">
                <thead className={headerClass}>
                    <tr>
                        <th>Sl. No.</th>
                        <th>Programme</th>
                        <th>Amount</th>
                        <th>Period (from – to)</th>
                        <th>
                            {showMaturityRenewal === false
                                ? "Select FDR"
                                : "Select FDR / Bank Guarantee"}
                        </th>
                        <th>
                            {showMaturityRenewal === false
                                ? "Enter FDR"
                                : "Enter FDR / Bank Guarantee No"}
                        </th>
                        <th>Date</th>
                        <th>Name &amp; Address of Issuing Bank</th>
                        <th>IFSC</th>
                        {showMaturityRenewal && <th>Date of Maturity</th>}
                        {showMaturityRenewal && <th>Date of Renewal</th>}
                        <th>
                            {showMaturityRenewal === false
                                ? "Upload FDR"
                                : "Upload FDR / Bank Guarantee"}
                        </th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((_, i) => {
                        const base = `${fieldName}[${i}]`
                        return (
                            <tr key={i}>
                                <td className="text-center">{i + 1}</td>

                                <td>
                                    <Field
                                        as="select"
                                        name={`${base}.courseId`}
                                        className="form-control form-control-sm"
                                    >
                                        <option value="">---Select Programme---</option>

                                        {(() => {
                                            const selectedProgrammes =
                                                formik.values[fieldName]
                                                    ?.map((r) => r.programme)
                                                    ?.filter(Boolean) || [];

                                            return (courses || [])
                                                .filter((course) => {
                                                    const currentValue =
                                                        formik.values[fieldName][i]?.programme;

                                                    return (
                                                        !selectedProgrammes.includes(
                                                            String(course.course_id),
                                                        ) ||
                                                        String(course.course_id) === String(currentValue)
                                                    );
                                                })
                                                .map((course) => (
                                                    <option
                                                        key={course.course_id}
                                                        value={course.course_id}
                                                    >
                                                        {course.course_name}
                                                    </option>
                                                ));
                                        })()}
                                    </Field>

                                    <FieldErr name={`${base}.courseId`} />
                                </td>
                                <td>
                                    <Field type="text" name={`${base}.amount`}
                                        className="form-control form-control-sm" placeholder="Amount" />
                                    <FieldErr name={`${base}.amount`} />
                                </td>

                                <td>
                                    <div className="d-flex gap-1 align-items-center">
                                        <div>
                                            <Field
                                                type="date"
                                                name={`${base}.periodFrom`}
                                                max={new Date().toISOString().split("T")[0]}
                                                className="form-control form-control-sm"
                                            />
                                            <FieldErr name={`${base}.periodFrom`} />
                                        </div>

                                        <span>–</span>

                                        <div>
                                            <Field
                                                type="date"
                                                name={`${base}.periodTo`}
                                                min={
                                                    formik.values?.[fieldName]?.[i]?.periodFrom || ""
                                                }
                                                className="form-control form-control-sm"
                                            />
                                            <FieldErr name={`${base}.periodTo`} />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <Field as="select" name={`${base}.fdrType`} className="form-control select-input" >
                                        <option value="">Select type</option>
                                        <option value="FDR">FDR</option>
                                        <option value="Bank Guarantee"> Bank Guarantee </option>
                                    </Field>
                                    <FieldErr name={`${base}.fdrType`} />
                                </td>
                                <td>
                                    <Field type="text" name={`${base}.fdrBankNumber`} className="form-control form-control-sm" placeholder="FDR No / Bank Guarantee No." />
                                    <FieldErr name={`${base}.fdrBankNumber`} />
                                </td>

                                <td>
                                    <Field
                                        type="date"
                                        name={`${base}.corpusDate`}
                                        className="form-control form-control-sm"
                                        max={new Date().toISOString().split("T")[0]}
                                    />
                                    <FieldErr name={`${base}.corpusDate`} />
                                </td>
                                <td>
                                    <Field
                                        type="text"
                                        name={`${base}.bankAddress`}
                                        className="form-control form-control-sm"
                                        placeholder="Bank name "
                                    />
                                    <FieldErr name={`${base}.bankAddress`} />
                                </td>

                                <td>
                                    <Field
                                        type="text"
                                        name={`${base}.ifsc`}
                                        className="form-control form-control-sm"
                                        placeholder=" Enter IFSC "
                                    />
                                    <FieldErr name={`${base}.ifsc`} />
                                </td>
                                {showMaturityRenewal && (
                                    <td>
                                        <Field
                                            type="date"
                                            name={`${base}.dateMaturity`}
                                            className="form-control form-control-sm"
                                            onChange={(e) => {
                                                formik.setFieldValue(`${base}.dateMaturity`, e.target.value);
                                                formik.setFieldTouched(`${base}.dateMaturity`, true);
                                            }}
                                        />
                                        <FieldErr name={`${base}.dateMaturity`} />
                                    </td>
                                )}
                                {showMaturityRenewal && (
                                    <td>
                                        <Field
                                            type="date"
                                            name={`${base}.dateRenewal`}
                                            className="form-control form-control-sm"
                                            onChange={(e) => {
                                                formik.setFieldValue(`${base}.dateRenewal`, e.target.value);
                                                formik.setFieldTouched(`${base}.dateRenewal`, true);
                                            }}
                                        />
                                        <FieldErr name={`${base}.dateRenewal`} />
                                    </td>
                                )}

                                <td>
                                    <input
                                        type="file"
                                        className="form-control form-control-sm"
                                        accept="application/pdf"
                                        onChange={(e) => {
                                            let filename = `uploadFdr_${i}`;
                                            let path = "/Uploads/FDRDocuments/";

                                            ImagePdfBucket(
                                                e,
                                                formik,
                                                path,
                                                `${base}.uploadFdr`,
                                                filename,
                                                "pdf"
                                            );
                                        }}
                                    />
                                    <FieldErr name={`${base}.uploadFdr`} />
                                    {formik.values?.[fieldName]?.[i]?.uploadFdr && (
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm mt-1"
                                            onClick={() =>
                                                viewImage(formik.values[fieldName][i].uploadFdr)
                                            }
                                        >
                                            <FaEye />
                                        </button>
                                    )}
                                </td>
                                <td className="text-center">
                                    {i === 0 ? (
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            onClick={addRow}
                                        >
                                            <VscDiffAdded />
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => removeRow(i)}
                                        >
                                            <BiTrash />
                                        </button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

// ── main component ────────────────────────────────────────────────────────────
export default function EOP({ paymentDone }) {
    const [hasPG, setHasPG] = useState(false);
    const [clgtype, setClgtype] = useState([]);
    const [clgYear, setClgYear] = useState("");
    const [ugData, setUgData] = useState(null);
    const [pgData, setPgData] = useState(null);
    const [ugCourse, setUgCourse] = useState([]);
    const [pgCourse, setPgCourse] = useState([]);

    function GetUgCourses() {
        CommonAxiosGet(`${config.url.FAC_URL}getUGCourses`).then((res) => {
            if (res?.data?.scode === "01") {
                setUgCourse(res.data.data);
            } else {
                setUgCourse([]);
            }
        });
    }

    function GetPGCourses() {
        CommonAxiosGet(`${config.url.FAC_URL}getPGCourses`).then((res) => {
            if (res?.data?.scode === "01") {
                setPgCourse(res.data.data);
            } else {
                setPgCourse([]);
            }
        });
    }
    console.log("PG Data:", pgData, ugData);
    function GetClgtype() {
        CommonAxiosGet(`${config.url.FAC_URL}getCourseTypes`).then((res) => {
            if (res?.data?.scode === "01") {
                const data = res.data.data || [];
                setClgtype(data);

                const ug = data.find((d) => d.course_type === "UG") || "";
                const pg = data.find((d) => d.course_type === "PG") || "";
                setUgData(ug);
                setPgData(pg);

                if (pg) setHasPG(true);

                const year = ug?.year_of_establishment ?? pg?.year_of_establishment
                if (year) {
                    setClgYear(String(year))
                    formik.setFieldValue('establishYear', String(year))
                }
            }
        })
    }

    useEffect(() => {
        GetClgtype()
        GetUgCourses();
        GetPGCourses();
    }, [])

    const havUG = clgtype?.some(item => item.course_type === "UG");
    const havPG = clgtype?.some(item => item.course_type === "PG");

    const showPGCorpus = havUG && havPG;
    const estYear = parseInt(clgYear) || 0;
    const isBefore = estYear > 0 && estYear <= CUTOFF_YEAR;
    const isAfter = estYear > 0 && estYear > CUTOFF_YEAR;


    // const getValidationSchema = (hasUG, hasPG, isBefore, isAfter) =>
    //     Yup.object({
    //         ruralArea: Yup.string().required("Please select Rural/Tribal area"),
    //         programSanction: Yup.string().required("Please select Program Sanction"),
    //         mroDocument: Yup.string().when("ruralArea", {
    //             is: "Yes",
    //             then: () => Yup.string().required("MRO document is required"),
    //             otherwise: () => Yup.string().nullable(),
    //         }),

    //         before2122Details: Yup.array().when([], {
    //             is: () => hasUG && isBefore,
    //             then: () =>
    //                 Yup.array().of(
    //                     Yup.object({
    //                         amount: Yup.string().required(ERROR_MSG),
    //                         fromDate: Yup.string().required(ERROR_MSG),
    //                         toDate: Yup.string().required(ERROR_MSG),
    //                         fdrBankGuarantee: Yup.string().required(ERROR_MSG),
    //                         dateOfFdr: Yup.string().required(ERROR_MSG),
    //                         bankAddress: Yup.string().required(ERROR_MSG),
    //                         ifsc: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION),
    //                         uploadFdrBankGaurantee: Yup.string().required(ERROR_MSG),
    //                         dateOfMaturity: Yup.string().required(ERROR_MSG),
    //                         dateOfRenewal: Yup.string().required(ERROR_MSG),
    //                     })
    //                 ),
    //             otherwise: () => Yup.array().notRequired(),
    //         }),

    //         after2122Details: Yup.array().when([], {
    //             is: () => hasUG && isAfter,
    //             then: () =>
    //                 Yup.array().of(
    //                     Yup.object({
    //                         courseId: Yup.string().required(ERROR_MSG),
    //                         amount: Yup.string().required(ERROR_MSG),
    //                         periodFrom: Yup.string().required(ERROR_MSG),
    //                         periodTo: Yup.string().required(ERROR_MSG),
    //                         fdrType: Yup.string().required(ERROR_MSG),
    //                         fdrBankNumber: Yup.string().required(ERROR_MSG),
    //                         corpusDate: Yup.string().required(ERROR_MSG),
    //                         bankAddress: Yup.string().required(ERROR_MSG),
    //                         ifsc: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION),
    //                         uploadFdr: Yup.string().required(ERROR_MSG),
    //                     })
    //                 ),
    //             otherwise: () => Yup.array().notRequired(),
    //         }),

    //         pgDetails: Yup.array().when([], {
    //             is: () => hasPG,
    //             then: () =>
    //                 Yup.array().of(
    //                     Yup.object({
    //                         courseId: Yup.string().required(ERROR_MSG),
    //                         amount: Yup.string().required(ERROR_MSG),
    //                         periodFrom: Yup.string().required(ERROR_MSG),
    //                         periodTo: Yup.string().required(ERROR_MSG),
    //                         fdrType: Yup.string().required(ERROR_MSG),
    //                         fdrBankNumber: Yup.string().required(ERROR_MSG),
    //                         corpusDate: Yup.string().required(ERROR_MSG),
    //                         bankAddress: Yup.string().required(ERROR_MSG),
    //                         ifsc: Yup.string().required(ERROR_MSG).matches(IFSC_VALIDATION),
    //                         uploadFdr: Yup.string().required(ERROR_MSG),
    //                         dateMaturity: Yup.string().required(ERROR_MSG),
    //                         dateRenewal: Yup.string().required(ERROR_MSG),
    //                     })
    //                 ),
    //             otherwise: () => Yup.array().notRequired(),
    //         }),
    //     });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ruralArea: '',
            mroDocument: '',
            programSanction: "",

            before2122Details: [blankInstallment()],

            after2122Details: [{
                courseId: '',
                amount: '',
                periodFrom: '',
                periodTo: '',
                fdrBankNumber: '',
                fdrType: '',
                corpusDate: '',
                bankAddress: '',
                dateMaturity: '',
                dateRenewal: '',
                uploadFdr: ''
            }],

            pgDetails: [{
                courseId: '',
                amount: '',
                periodFrom: '',
                periodTo: '',
                fdrBankNumber: '',
                fdrType: '',
                corpusDate: '',
                bankAddress: '',
                dateMaturity: '',
                dateRenewal: '',
                uploadFdr: ''
            }]
        },

        // validationSchema: getValidationSchema(havUG, havPG, isBefore, isAfter),
        validationSchema: Yup.object().shape({
            ruralArea: Yup.string().required("Please select Rural/Tribal area"),

            mroDocument: Yup.string().when("ruralArea", {
                is: "Yes",
                then: () => Yup.string().required("MRO document is required"),
                otherwise: () => Yup.string().notRequired(),
            }),

            programSanction: Yup.string().required("Please select Program Sanction"),

            // ================= BEFORE 2021-22 =================
            before2122Details: Yup.array().when(["ruralArea"], {
                is: (ruralArea) => ruralArea === "No",
                then: () =>
                    Yup.array().of(
                        Yup.object({
                            amount: Yup.string().required("Required"),
                            fromDate: Yup.string().required("Required"),
                            toDate: Yup.string().required("Required"),
                            fdrBankGuarantee: Yup.string().required("Required"),
                            dateOfFdr: Yup.string().required("Required"),
                            bankAddress: Yup.string().required("Required"),
                            ifsc: Yup.string().required("Required"),
                            uploadFdrBankGaurantee: Yup.string().required("Required"),
                        })
                    ),
                otherwise: () => Yup.array().notRequired(),
            }),

            // ================= AFTER 2021-22 UG =================
            after2122Details: Yup.array().when("programSanction", {
                is: "Yes",
                then: () =>
                    Yup.array().of(
                        Yup.object({
                            courseId: Yup.string().required("Required"),
                            amount: Yup.string().required("Required"),
                            periodFrom: Yup.string().required("Required"),
                            periodTo: Yup.string().required("Required"),
                            fdrType: Yup.string().required("Required"),
                            fdrBankNumber: Yup.string().required("Required"),
                            corpusDate: Yup.string().required("Required"),
                            bankAddress: Yup.string().required("Required"),
                            ifsc: Yup.string().required("Required"),
                            uploadFdr: Yup.string().required("Required"),
                        })
                    ),
                otherwise: () => Yup.array().notRequired(),
            }),

            // ================= PG =================
            pgDetails: Yup.array().when("programSanction", (programSanction, schema) => {
                if (programSanction === "Yes" && !!pgData) {
                    return schema.of(
                        Yup.object({
                            courseId: Yup.string().required("Required"),
                            amount: Yup.string().required("Required"),
                            periodFrom: Yup.string().required("Required"),
                            periodTo: Yup.string().required("Required"),
                            fdrType: Yup.string().required("Required"),
                            fdrBankNumber: Yup.string().required("Required"),
                            corpusDate: Yup.string().required("Required"),
                            bankAddress: Yup.string().required("Required"),
                            ifsc: Yup.string().required("Required"),
                            uploadFdr: Yup.string().required("Required"),
                            dateMaturity: Yup.string().required("Required"),
                            dateRenewal: Yup.string().required("Required"),
                        })
                    );
                }

                return schema.notRequired();
            }),
        }),
        onSubmit: (values) => {
            const before2122Details = values.before2122Details.map((item, idx) => ({
                ...item,
                installmentNo: idx + 1,
            }));

            const payload = {
                ...values,
                before2122Details,
                after2122Details: values.after2122Details,
                pgDetails: values.pgDetails,
            };

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.FAC_URL + `saveCorpusFundDetailsBefore2122`
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                        }
                        else if (res?.data?.scode === '02') {
                            Swal.fire(res?.data?.sdesc, '', 'error').then((res) => {
                            })
                        }
                        else {
                            failureAlert("Failed to submit")
                        }
                    })
                }
            });
        }
    })

    useEffect(() => {
        const y = yearsCompleted(formik.values.establishYear);
        formik.setFieldValue("leasedYears", y);
    }, [formik.values.establishYear]);

    const [clgdata, setClgdata] = useState([]);

    function GetCollegeData() {
        CommonAxiosGet(`${config.url.FAC_URL}getInstitutionPolyDetails`).then((res) => {
            const data = res?.data?.data?.[0] || {};
            setClgdata(data);
        });
    }

    // ✅ FIXED: direct setValues, no prev callback
    // function mapEopToFormik(data) {
    //     const afterData = (data?.corpusfundUGPG || []).map(item => ({
    //         courseId: item.course_id || '',
    //         amount: item.amount || '',
    //         periodFrom: item.period_from || '',
    //         periodTo: item.period_to || '',
    //         fdrBankNumber: item.fdr_bank_number || '',
    //         fdrType: item.fdr_type || '',
    //         corpusDate: item.corpus_date || '',
    //         bankAddress: item.bank_address || '',
    //         ifsc: item.ifsc || '',
    //         dateMaturity: item.date_maturity || '',
    //         dateRenewal: item.date_renewal || '',
    //         uploadFdr: item.upload_fdr || ''
    //     }));

    //     const beforeData = (data?.corpusFundInstall || []).map(item => ({
    //         amount: item.amount || '',
    //         fromDate: item.from_date || '',
    //         toDate: item.to_date || '',
    //         fdrBankGuarantee: item.fdr_bank_guarantee || '',
    //         fdrType: item.fdr_type || '',
    //         dateOfFdr: item.date_of_fdr || '',
    //         bankAddress: item.bank_address || '',
    //         ifsc: item.ifsc || '',
    //         dateOfMaturity: item.date_of_maturity || '',
    //         dateOfRenewal: item.date_of_renewal || '',
    //         uploadFdrBankGaurantee: item.upload_fdr_bank_gaurantee || ''
    //     }));

    //     const ruralArea = data?.corpusFundInstall?.[0]?.rural_area || '';
    //     const mroDocument = data?.corpusFundInstall?.[0]?.mro_document || '';

    //     // ✅ Direct object — no prev callback
    //     formik.setValues({
    //         ruralArea,
    //         mroDocument,
    //         before2122Details: beforeData.length ? beforeData : [blankInstallment()],
    //         after2122Details: afterData.length ? afterData : formik.values.after2122Details,
    //         pgDetails: formik.values.pgDetails,
    //     });
    // }

    function mapEopToFormik(data) {

        const ugpgList = Array.isArray(data?.corpusfundUGPG)
            ? data.corpusfundUGPG
            : [];

        const installList = Array.isArray(data?.corpusFundInstall)
            ? data.corpusFundInstall
            : [];

        const afterData = ugpgList.map(item => ({
            courseId: item.course_id || '',
            amount: item.amount || '',
            periodFrom: item.period_from || '',
            periodTo: item.period_to || '',
            fdrBankNumber: item.fdr_bank_number || '',
            fdrType: item.fdr_type || '',
            corpusDate: item.corpus_date || '',
            bankAddress: item.bank_address || '',
            ifsc: item.ifsc || '',
            dateMaturity: item.date_maturity || '',
            dateRenewal: item.date_renewal || '',
            uploadFdr: item.upload_fdr || ''
        }));

        const beforeData = installList.map(item => ({
            amount: item.amount || '',
            fromDate: item.from_date || '',
            toDate: item.to_date || '',
            fdrBankGuarantee: item.fdr_bank_guarantee || '',
            fdrType: item.fdr_type || '',
            dateOfFdr: item.date_of_fdr || '',
            bankAddress: item.bank_address || '',
            ifsc: item.ifsc || '',
            dateOfMaturity: item.date_of_maturity || '',
            dateOfRenewal: item.date_of_renewal || '',
            uploadFdrBankGaurantee: item.upload_fdr_bank_gaurantee || ''
        }));

        const ruralArea = installList?.[0]?.rural_area || '';
        const mroDocument = installList?.[0]?.mro_document || '';
        const programSanction = installList?.[0]?.programsanction || '';

        formik.setValues({
            ruralArea,
            mroDocument, programSanction,
            before2122Details: beforeData.length ? beforeData : [blankInstallment()],
            after2122Details: afterData.length
                ? afterData
                : [{
                    courseId: '',
                    amount: '',
                    periodFrom: '',
                    periodTo: '',
                    fdrBankNumber: '',
                    fdrType: '',
                    corpusDate: '',
                    bankAddress: '',
                    dateMaturity: '',
                    dateRenewal: '',
                    uploadFdr: ''
                }],
            pgDetails: formik.values.pgDetails,
        });
    }

    // ✅ FIXED: res.data is the response body from CommonAxiosGet
    function GetEopDetails() {
        CommonAxiosGet(`${config.url.FAC_URL}getEOPDetails`).then((res) => {
            const data = res?.data || {};
            mapEopToFormik(data);
        });
    }
    console.log("formik", formik?.errors)
    useEffect(() => {
        GetCollegeData();
        GetEopDetails();
    }, [])

    const labelStyle = {
        fontWeight: 600,
        color: "#004d40",
        marginBottom: 6,
        fontSize: 18,
    };
    const getBlankAfterRow = () => ({
        courseId: '',
        amount: '',
        periodFrom: '',
        periodTo: '',
        fdrBankNumber: '',
        fdrType: '',
        corpusDate: '',
        bankAddress: '',
        dateMaturity: '',
        dateRenewal: '',
        uploadFdr: ''
    });
    return (
        <>
            <div className="faculty-form-wrapper">
                <div className="faculty-card">
                    <SectionHeader title="Extension of Permission (EoP)" />

                    <FormikProvider value={formik}>
                        {/* <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit}> */}
                        <Form onSubmit={formik.handleSubmit}>

                            <bie.Row>
                                <bie.Col xs={12} md={4} lg={4} className="mb-3">
                                    <div style={labelStyle}>
                                        <strong>Year of Establishment:</strong> {clgdata?.year_of_establishment || "--"}
                                    </div>
                                </bie.Col>
                                {/* <bie.Col xs={12} md={4} lg={4} className="mb-3">
                                    <label className="mb-1">
                                        <b className="field-mandatory">
                                            Whether the college is located in a Rural / Tribal area
                                        </b>
                                    </label>
                                    <div className="mt-1">
                                        <Field type="radio" name="ruralArea" value="Yes"

                                        />&nbsp;Yes&emsp;
                                        <Field type="radio" name="ruralArea" value="No" />&nbsp;No
                                    </div>
                                    <FieldErr name="ruralArea" />
                                </bie.Col> */}
                                <bie.Col xs={12} md={4} lg={4} className="mb-3">
                                    <label className="mb-1">
                                        <b className="field-mandatory">
                                            Whether the college is located in a Rural / Tribal area
                                        </b>
                                    </label>
                                    <Field
                                        type="radio"
                                        name="ruralArea"
                                        value="Yes"
                                        onChange={(e) => {
                                            formik.handleChange(e); // updates ruralArea
                                            formik.setFieldValue("before2122Details", [blankInstallment()]);
                                            formik.setFieldValue("mroDocument", '');

                                        }}
                                    />
                                    &nbsp;Yes&emsp;

                                    <Field
                                        type="radio"
                                        name="ruralArea"
                                        value="No"
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            formik.setFieldValue("before2122Details", [blankInstallment()]); // reset here also if needed
                                            formik.setFieldValue("mroDocument", '');

                                        }}
                                    />
                                    &nbsp;No
                                </bie.Col>

                                {formik.values.ruralArea === 'Yes' && (
                                    <bie.Col xs={12} md={4} lg={4} className="mb-3">
                                        <label className="mb-1">
                                            <b className="field-mandatory">Upload the certificate issued by concerned MRO</b>
                                        </label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="application/pdf"
                                            onChange={(e) => {
                                                const filename = "_mroDocument";
                                                const path = "/Uploads/MroDocument/";
                                                ImagePdfBucket(e, formik, path, "mroDocument", filename, "pdf");
                                            }}
                                        />
                                        <FieldErr name="mroDocument" />
                                        {formik.values.mroDocument && (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm mt-2"
                                                onClick={() => viewImage(formik.values.mroDocument)}
                                            ><FaEye />
                                            </button>
                                        )}
                                    </bie.Col>
                                )}
                            </bie.Row>

                            {ugData && estYear > 0 && (
                                <div className="px-2 mt-2">
                                    <h6 className="innerheader-new">
                                        <span>UG Corpus Fund</span>
                                    </h6>

                                    {isBefore && formik?.values?.ruralArea === "No" && (
                                        <TransposedBeforeTable
                                            fieldName="before2122Details"
                                            label=" For Degree Colleges established before 2021-22"
                                            hasProgramme={false}
                                            headerClass="table-primary"
                                            labelClass="text-primary"
                                            formik={formik}
                                        />
                                    )}



                                    <bie.Col xs={12} md={4} lg={4} className="mb-3">
                                        <label className="mb-1">
                                            <b className="field-mandatory">
                                                Whether any New Programmes sanctioned after 2021-22
                                            </b>
                                        </label>
                                        <div className="mt-1">

                                            {/* <Field
                                                type="radio"
                                                name="programSanction"
                                                value="Yes"
                                                onChange={(e) => {
                                                    formik.setFieldValue("programSanction", e.target.value);
                                                    formik.setFieldTouched("programSanction", true);

                                                }}
                                            />&nbsp;Yes &emsp;

                                            <Field
                                                type="radio"
                                                name="programSanction"
                                                value="No"
                                                onChange={(e) => {
                                                    formik.setFieldValue("programSanction", e.target.value);
                                                    formik.setFieldTouched("programSanction", true);
                                                    formik.setFieldValue("after2122Details", []);

                                                }}
                                            />&nbsp;No */}
                                            <Field
                                                type="radio"
                                                name="programSanction"
                                                value="Yes"
                                                onChange={(e) => {
                                                    formik.handleChange(e);
                                                    formik.setFieldTouched("programSanction", true);

                                                    formik.setFieldValue("after2122Details", [getBlankAfterRow()]);
                                                    formik.setFieldValue("pgDetails", [getBlankAfterRow()]);
                                                }}
                                            /> &nbsp;Yes &emsp;

                                            <Field
                                                type="radio"
                                                name="programSanction"
                                                value="No"
                                                onChange={(e) => {
                                                    formik.handleChange(e);
                                                    formik.setFieldTouched("programSanction", true);

                                                    formik.setFieldValue("after2122Details", [getBlankAfterRow()]);
                                                    formik.setFieldValue("pgDetails", [getBlankAfterRow()]);
                                                }}
                                            /> &emsp;No

                                        </div>
                                        <FieldErr name="programSanction" />
                                    </bie.Col>
                                    {formik?.values?.programSanction === "Yes" && (
                                        <div className={isBefore ? "mt-3" : ""}>
                                            <RowAfterTable
                                                fieldName="after2122Details"
                                                label=" For Degree Colleges / programmes sanctioned after 2021-22"
                                                showMaturityRenewal={false}
                                                headerClass="table-primary"
                                                labelClass="text-primary"
                                                formik={formik}
                                                courses={ugCourse}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}

                            {showPGCorpus && formik?.values?.programSanction === "Yes" && (
                                <div className="px-2 mt-4">
                                    <h6 className="innerheader-new"><span>PG Corpus Fund</span></h6>

                                    {isBefore && (
                                        <RowAfterTable
                                            fieldName="pgDetails"
                                            label=" For existing PG Programmes sanctioned (before 2021-22 and after 2021-22)"
                                            showMaturityRenewal={true}
                                            headerClass="table-success"
                                            labelClass="text-success"
                                            formik={formik}
                                            courses={pgCourse}
                                        />
                                    )}
                                </div>
                            )}



                            <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                                {paymentDone ? (
                                    <div style={{ color: "green", fontWeight: "bold" }}>
                                        ✅ Already submitted
                                    </div>
                                ) : (
                                    <button
                                        type="submit"
                                        className="btn btn-success btn-sm"
                                    >
                                        Submit
                                    </button>
                                )}
                            </div>

                        </Form>
                    </FormikProvider>
                </div>
            </div>
        </>
    )
}